export default __webpack_public_path__ + "static/logo-white-351f402f7124f811f9bcc979aaa64f1c.svg";